import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SettingsService {
  private subjects = new Map<string, BehaviorSubject<any>>();
  private prefix = "app_setting_";

  get<T>(key: string, defaultValue: T): Observable<T> {
    return this.getOrCreate(key, defaultValue).asObservable();
  }

  getValue<T>(key: string, defaultValue: T): T {
    return this.getOrCreate(key, defaultValue).value;
  }

  set(key: string, value: any): void {
    const subject = this.getOrCreate(key, value);
    subject.next(value);
    localStorage.setItem(this.prefix + key, JSON.stringify(value));
  }

  private getOrCreate<T>(key: string, defaultValue: T): BehaviorSubject<T> {
    if (!this.subjects.has(key)) {
      const stored = localStorage.getItem(this.prefix + key);
      const initial = stored !== null ? JSON.parse(stored) : defaultValue;
      this.subjects.set(key, new BehaviorSubject<T>(initial));
    }
    return this.subjects.get(key)!;
  }
}
